<template>
    <div>
        <el-form style="background: #fff; padding: 20px" class="topForm" ref="form" :rules="rules" :model="form" status-icon
            label-width="100px">
            <el-container
                style="background: #fff; border-radius: 15px; padding-top: 20px; padding-right: 20px; margin-bottom: 10px">
                <el-main style="padding: 0 20px 0 0;display:flex;justify-content:space-between">
                    <div style="display:flex;flex:8">
                        <el-form-item label="开始日期" prop="begin_date" style="flex:2">
                            <el-date-picker type="date" value-format="yyyy-MM-dd" placeholder="选择日期"
                                v-model="form.begin_date" style="width: 100%"></el-date-picker>
                        </el-form-item>
                        <el-form-item label="结束日期" prop="end_date" style="flex:2">
                            <el-date-picker type="date" value-format="yyyy-MM-dd" placeholder="选择日期" v-model="form.end_date"
                                style="width: 100%"></el-date-picker>
                        </el-form-item>

                        <el-form-item :label="$t('common.customer') " style="flex:2;">
                            <label slot="label">客&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;户</label>
                            <mySelect v-model="form.cust_no" :options="allArr.custs" values="kind_no" labels="kind_name"
                                keys="kind_no" style="width: 100%" />
                        </el-form-item>
                    </div>
                    <div style="flex:1;margin-left:1%">
                        <el-button type="primary" @click="searchIt()">&emsp;{{ $t('common.search') }}&emsp;</el-button>
                    </div>
                </el-main>
            </el-container>

            <el-table style="font-size:14px" :data="tableData" border class="table" ref="multipleTable"
                header-cell-class-name="table-header">
                <template slot="empty">
                    <div style="display:flex;justify-content:center;align-items:center;height:500px">
                        <img src="@/assets/img/dontHave.png" alt="" style="width:250px;height:250px" />
                    </div>
                </template>
                <el-table-column type="index" width="50" align="center" label="序号"> </el-table-column>
                <el-table-column prop="cust_name" label="客户名称"></el-table-column>
                <el-table-column prop="前一天存欠料" label="前一天存欠料"></el-table-column>
                <el-table-column prop="前两天存欠料" label="前两天存欠料"></el-table-column>
                <el-table-column prop="实时存欠料" label="实时存欠料"></el-table-column>
                <el-table-column prop="当天实收货" label="当天实收货"></el-table-column>
                <el-table-column prop="本月进货" label="本月进货"></el-table-column>
                <el-table-column prop="本月退货" label="本月退货"></el-table-column>
                <el-table-column prop="退货率" label="退货率"></el-table-column>
            </el-table>
            <div class="pagination">
                <el-pagination background layout="total, sizes, prev, pager, next, jumper" :current-page="form.page"
                    :page-size="form.page_size" :page-sizes="[10, 50, 100, pageTotal]" :total="pageTotal"
                    @current-change="handlePageChange" @size-change="pageSizeChange"></el-pagination>
            </div>
        </el-form>
    </div>
</template>

<script>
import { apiCustList, apiCustListPull, apiCurrentPermisson, apiSystem, vendorInsale } from '@/request/api';
import axios from 'axios';
import mySelect from '@/components/component/select.vue';
export default {
    name: 'custInterest',
    data() {
        return {
            form: {
                begin_date: '',
                end_date: '',
                page: 1,
                page_size: 10
            },
            rules: {
                begin_date: [{ required: true, message: '请选择起始日期', trigger: 'change' }],
                end_date: [{ required: true, message: '请选择结束日期', trigger: 'change' }]
            },
            allArr: '',

            pageTotal: 0,
            perData: '',
            systemSet: '',
            tableData: []
        };
    },
    components: { mySelect },
    created() { },
    mounted() {
        this.form.begin_date = this.$route.query.begin_date;
        this.form.end_date = this.$route.query.end_date;
        this.form.cust_no = this.$route.query.cust_no;
        console.log(this.form.begin_date, this.form.end_date, this.form.cust_no);
        if (this.form.begin_date && this.form.end_date) {
            this.getData();
            console.log('made');
        } else {
            var d = new Date();
            var a = d.getFullYear() + '-' + (d.getMonth() + 1) + '-' + d.getDate();
            this.form.begin_date = a;
            this.form.end_date = a;
        }
        this.getPull();
        this.getPermission();
    },

    activated() {
        this.form.begin_date = this.$route.query.begin_date;
        this.form.end_date = this.$route.query.end_date;
        this.form.cust_no = this.$route.query.cust_no;
        if (this.form.begin_date && this.form.end_date) {
            this.getData();
            console.log('made');
        } else {
            var d = new Date();
            var a = d.getFullYear() + '-' + (d.getMonth() + 1) + '-' + d.getDate();
            this.form.begin_date = a;
            this.form.end_date = a;
        }
    },
    methods: {
        getPull() {
            apiCustListPull({}).then(res => {
                if (res.code == 2000) {
                    this.allArr = res.data;
                } else {
                    this.message('err', res);
                }
            });
        },
        searchIt() {
            this.form.page = 1;
            this.form.page_size = 10;
            this.getData();
        },
        getData() {
            this.$refs.form.validate(valid => {
                if (valid) {
                    vendorInsale(this.form).then(res => {
                        console.log(res);
                        if (res.code == 2000) {
                            this.tableData = res.data.dtl;
                            this.pageTotal = res.data.count;
                            // this.Query(type);
                        } else {
                            this.tableData = [];
                            this.pageTotal = 0;
                            this.message('err', res);
                        }
                    });
                } else {
                    // this.$message.error('请选择必填信息');
                    return false;
                }
            });
        },

        // 错误提示 封装
        message(type, res) {
            if (type == 'suc') {
                this.$message({
                    type: 'success',
                    message: res.msg,
                    duration: 2000,
                    showClose: true
                });
            } else if (type == 'err') {
                this.$message.error({
                    message: res.data.info,
                    duration: 2000,
                    showClose: true
                });
            }
        },
        // 分页导航----------------------------------------------------------------------------------------------------
        handlePageChange(val) {
            this.$set(this.form, 'page', val);
            this.getData();
        },
        pageSizeChange(val) {
            //console.log(`每页 ${val} 条`);
            this.$set(this.form, 'page_size', val);
            this.getData();
        },
        //获得页面按钮的权限（添加，修改，删除）
        getPermission() {
            apiCurrentPermisson({
                id: '78'
            }).then(res => {
                if (res.code == 2000) {
                    console.log(res.data);
                    this.perData = res.data;
                } else {
                    this.message('err', res);
                }
            });
        },
        //获取系统设置信息
        getSystem() {
            apiSystem({}).then(res => {
                if (res.code == 2000) {
                    this.systemSet = res.data;
                } else {
                    this.message('err', res);
                }
            });
        }
    }
};
</script>

<style scoped>
.company {
    text-align: center;
    font-size: 16px;
    color: rgb(7, 16, 114);
    font-weight: bold;
    letter-spacing: 5px;
}

.custtable .el-select {
    width: 80%;
    margin-top: 10px;
}

@media print {
    table {
        width: 100%;
        border-collapse: collapse;
        font-size: 12px;
    }
}
</style>
